module.exports = __webpack_public_path__ + "img/ar.a4f4977e.svg";